export default "__VITE_ASSET__BrCQNs0N__"